module.exports = new __parcel__URL__("75137_sq.130c15cb.jpg").toString();